import React, { useState } from "react";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import isGHMC from "../../../../Common/helper/helpar";
import { CircleWiseSATsReports } from "./CircleWiseSATsReports/CircleWiseSATsReports";
import { ZoneWiseSATsReports } from "./ZoneWiseSATsReports/ZoneWiseSATsReports";

const TripTSSCTP = () => {
  const currentTab = localStorage.getItem("sat-trips-active-tab");
  const [selectedTab, setSelectedTab] = useState(currentTab || 0)
  const isProd = isGHMC();
  const zoneTabClassNames = `datatable_tabs ${isProd ? selectedTab == 0 ? "active-ghmc" : "active-swm" : selectedTab == 0 ? "active-default" : "inactive-default"}`
  const circleTabClassNames = `datatable_tabs ${isProd ? selectedTab == 1 ? "active-ghmc" : "active-swm" : selectedTab == 1 ? "active-default" : "inactive-default"}`
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">SATs Trip to TS/SCTP</h4>
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <Tabs
                    selectedIndex={Number(selectedTab)}
                    onSelect={(index) => {setSelectedTab(index); localStorage.setItem("sat-trips-active-tab", index)}}
                  >
                    <TabList style={{ display: "none" }}>
                      <Tab />
                      <Tab />
                    </TabList>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-flex",
                        backgroundColor: "#f1f3f5",
                        borderRadius: "8px",
                        border: "1px solid #e4e6e9",
                        padding: "4px",
                        marginBottom: "16px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "4px",
                          bottom: "4px",
                          left: selectedTab === 0 ? "4px" : "calc(50% + 2px)",
                          width: "calc(50% - 6px)",
                          borderRadius: "5px",
                          backgroundColor: isProd ? "#1565C0" : "#c0392b",
                          boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                          transition: "left 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                          zIndex: 0,
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => { setSelectedTab(0); localStorage.setItem("sat-trips-active-tab", 0); }}
                        style={{
                          padding: "7px 18px",
                          background: "transparent",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          fontWeight: selectedTab === 0 ? "600" : "500",
                          fontSize: "13px",
                          color: selectedTab === 0 ? "#fff" : "#6c757d",
                          position: "relative",
                          zIndex: 1,
                          transition: "color 0.35s ease",
                          userSelect: "none",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className="fa-solid fa-layer-group me-2" />
                        Zone Wise
                      </button>
                      <button
                        type="button"
                        onClick={() => { setSelectedTab(1); localStorage.setItem("sat-trips-active-tab", 1); }}
                        style={{
                          padding: "7px 18px",
                          background: "transparent",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          fontWeight: selectedTab === 1 ? "600" : "500",
                          fontSize: "13px",
                          color: selectedTab === 1 ? "#fff" : "#6c757d",
                          position: "relative",
                          zIndex: 1,
                          transition: "color 0.35s ease",
                          userSelect: "none",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className="fa-solid fa-circle-dot me-2" />
                        Circle Wise
                      </button>
                    </div>
                    <TabPanel>
                      <ZoneWiseSATsReports />
                    </TabPanel>
                    <TabPanel>
                      <CircleWiseSATsReports />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TripTSSCTP;
